import { Injectable } from "@angular/core";
import { AssignmentDto, AssignmentType } from "../generated/backend";

@Injectable({
  providedIn: 'root'
})
export class AssignmentHelper {

  static isDelivery(assignmentType: AssignmentType): boolean {
    return assignmentType == AssignmentType.AssignmentDelivery ||
            assignmentType == AssignmentType.ReturnRentalOrder
  }

  static isPickup(assignmentType: AssignmentType): boolean {
    // AssignmentType.AssignmentPickup || AssignmentType.PickupRentalPurchasingOrder
    return !AssignmentHelper.isDelivery(assignmentType);
  }

  static effectiveVolume(assignment: AssignmentDto ): number {
    return assignment.Volume;
  }

  static effectiveWeight(assignment: AssignmentDto ): number {
    return assignment.Weight;
  }
}
